<template>
  <v-menu bottom left offset-y style="z-index: 1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on.capture="on">
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list style="text-align: start;">
      <v-list-item
        v-if="notification && notification.body.activityUuid && !viewAll"
        @click="executeTextAction('View', notification)"
      >
        <v-list-item-title>{{ actions.view }}</v-list-item-title>
      </v-list-item>

      <notification-menu-list
        v-if="notification && !viewAll"
        :actions="actions"
        :notification="notification"
        @executeTextAction="executeTextAction"
      />
      <notification-read-all-menu
        v-if="viewAll"
        :actions="actions"
        :allRead="allRead"
        @readAllNotifications="readAllNotifications"
      />

      <v-list-item v-if="viewAll" @click="deleteAllNotifications">
        <v-list-item-title>{{ actions.deleteAll }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-else @click="executeTextAction('Delete', notification)">
        <v-list-item-title>{{ actions.delete }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import NotificationMenuList from "../_Molecules/NotificationMenuList.vue";
import NotificationReadAllMenu from "../_Molecules/NotificationReadAllMenu.vue";

export default {
  name: "NotificationsMenu",

  components: {
    NotificationMenuList,
    NotificationReadAllMenu
  },

  props: {
    notification: {
      type: Object
    },
    viewAll: {
      type: Boolean
    },
    allRead: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      actions: {
        view: this.$i18n.t("View"),
        markAsUnread: this.$i18n.t("MarkAsUnread"),
        markAsRead: this.$i18n.t("MarkAsRead"),
        markAllAsRead: this.$i18n.t("MarkAllAsRead"),
        markAllAsUnread: this.$i18n.t("MarkAllAsUnread"),
        delete: this.$i18n.t("Delete"),
        deleteAll: this.$i18n.t("DeleteAll")
      }
    };
  },
  methods: {
    /**
     * @param {String} action - the action the user clicked (View or delete)
     * @param {Object} notification - notification the user has clicked.
     * Depending on the action, a function is attributed and executed.
     *
     */
    executeTextAction(action, notification) {
      if (action === "View") {
        if (notification.body.activityUuid) {
          this.$emit(
            "redirectToTask",
            notification.body.uuid,
            notification.body.activityUuid
          );
        }

        this.$emit("readNotification", notification.id);
      }
      if (action === "Delete") {
        this.$emit("deleteNotification", notification.id);
      }
      if (notification.readAt && !action) {
        this.$emit("unReadNotification", notification.id);
      }
      if (!notification.readAt && !action) {
        this.$emit("readNotification", notification.id);
      }
    },
    /**
     * @param {String} - sends read or unread string when the option is clicked.
     */
    readAllNotifications(value) {
      this.$emit("readAllNotifications", value);
    },
    /**
     * emits event to delete all notifications.
     */
    deleteAllNotifications() {
      this.$emit("deleteAllNotifications");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Management/Notifications/_Organisms/NotificationsMenu.vue